var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1612_3905)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12.75C3.86193 12.75 3.75 12.8619 3.75 13V19C3.75 19.1381 3.86193 19.25 4 19.25H8C8.13807 19.25 8.25 19.1381 8.25 19V13C8.25 12.8619 8.13807 12.75 8 12.75H4ZM2.25 13C2.25 12.0335 3.0335 11.25 4 11.25H8C8.9665 11.25 9.75 12.0335 9.75 13V19C9.75 19.9665 8.9665 20.75 8 20.75H4C3.0335 20.75 2.25 19.9665 2.25 19V13Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8.75C9.86193 8.75 9.75 8.86193 9.75 9V19C9.75 19.1381 9.86193 19.25 10 19.25H14C14.1381 19.25 14.25 19.1381 14.25 19V9C14.25 8.86193 14.1381 8.75 14 8.75H10ZM8.25 9C8.25 8.0335 9.0335 7.25 10 7.25H14C14.9665 7.25 15.75 8.0335 15.75 9V19C15.75 19.9665 14.9665 20.75 14 20.75H10C9.0335 20.75 8.25 19.9665 8.25 19V9Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4.75C15.8619 4.75 15.75 4.86193 15.75 5V19C15.75 19.1381 15.8619 19.25 16 19.25H20C20.1381 19.25 20.25 19.1381 20.25 19V5C20.25 4.86193 20.1381 4.75 20 4.75H16ZM14.25 5C14.25 4.0335 15.0335 3.25 16 3.25H20C20.9665 3.25 21.75 4.0335 21.75 5V19C21.75 19.9665 20.9665 20.75 20 20.75H16C15.0335 20.75 14.25 19.9665 14.25 19V5Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20H18",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.97959a3e574ae84dfa1d09a5a5fb2661.svg";
export { ForwardRef as ReactComponent };